import type { RawRow } from './catalog.js'

export const merchantFieldKeys = [
  'id', 'title', 'description', 'link', 'imageLink', 'availability', 'price',
  'brand', 'gtin', 'mpn', 'condition', 'identifierExists', 'itemGroupId',
] as const

export type MerchantFieldKey = (typeof merchantFieldKeys)[number]
export type MerchantMapping = Record<MerchantFieldKey, string>
export type MerchantSeverity = 'warning' | 'error'
export type MerchantStatus = 'pass' | 'warning' | 'error'

export interface MerchantIssue {
  code: string
  severity: MerchantSeverity
  field?: MerchantFieldKey
  message: string
  recommendation: string
}

export interface MerchantRow {
  sourceRowNumber: number
  id: string
  title: string
  raw: RawRow
  status: MerchantStatus
  issues: MerchantIssue[]
}

export interface MerchantRuleSet {
  id: string
  version: string
  title: string
  publishedAt: string
  effectiveFrom: string
  reviewedAt: string
  sourceUrl: string
  notices: string[]
}

export const emptyMerchantMapping = (): MerchantMapping => Object.fromEntries(
  merchantFieldKeys.map((field) => [field, '']),
) as MerchantMapping
